const getters = {
  getPatientData({ patientData }) {
    return patientData;
  },
  getPatientRef({ patientData }) {
    return patientData.ref;
  },
  getUserData({ userData }) {
    return userData;
  }
};

export default getters;
